/** Одна константа точности на всех потребителей: разъехавшись, они сломают сравнение черновиков в форме. */

/** 6 знаков ≈ 11 см — с запасом до подъезда; дальше только шум и рост записи в storage. */
export const COORD_DIGITS = 6;

export const LATITUDE_LIMIT = 90;
export const LONGITUDE_LIMIT = 180;

/** Единственная точка нормализации: без неё float-шум карты заводит петлю «форма ↔ черновик». */
export function roundCoord(value: number): number {
  return Number(value.toFixed(COORD_DIGITS));
}

/** Недоверенное значение отвергается, а не «чинится»: неверная координата хуже отсутствующей. */
export function readCoord(value: unknown, limit: number): number | null {
  return typeof value === 'number' && Number.isFinite(value) && Math.abs(value) <= limit
    ? roundCoord(value)
    : null;
}
